import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import DocumentHitsFormat from '@Components/Results/services/document-hits-format.service';
import { ClickableCard } from '@els/els-react--card';
import { Icon } from '@els/els-react--icon';

function DocumentAbstractHit({ abstractText, onOpen, trackingAttrs }) {
  const abstractHit = DocumentHitsFormat.checkAndFormatHit(abstractText, 'abstract');

  return abstractHit ? (
    <ClickableCard
      data-e2e="abstract-hit-open"
      className="result-detail-panel e2e-document-action-abstract-hit"
      aria-label="Open Abstract"
      {...trackingAttrs}
      onClick={onOpen}>
      <div className="u-els-display-flex document-hit-card__content">
        <h3 className="u-els-margin-right-1o2 u-els-font-family-bold u-els-font-size-base document-hit-card__title">Abstract hit:</h3>
        <InnerHTML tag="div" className="u-els-font-size-base document-hit-card__text" html={abstractHit} />
        <Icon
          sprite="ChevronDown"
          size="xs"
          isDecorative
          className="u-els-margin-left-1o2 result-detail-panel__chevron document-hit-card__chevron"
        />
      </div>
    </ClickableCard>
  ) : null;
}

DocumentAbstractHit.propTypes = {
  abstractText: PropTypes.string.isRequired,
  onOpen: PropTypes.func.isRequired,
  trackingAttrs: PropTypes.object.isRequired,
};

export default DocumentAbstractHit;
